import $ from 'jquery';

$('.media__content_play-media').on('click', function () {
	var $media__content = $(this).parent('.media__content')
	$media__content.hide();
	var $media =  $media__content.parent('.media');
	$media.find('.media__image').hide();

	var $iframe = $media.find('iframe')
	var old_src = $iframe.attr('src');

	// Autoplay if youtube video
	if (old_src.indexOf("youtube.com/embed") >= 0) {
		var new_src = old_src + '&autoplay=1';
		$iframe.attr('src', new_src);
	}
})